import React from 'react'
import Moment from 'react-moment'
import { Icon } from 'semantic-ui-react'
import { upper, lower } from 'change-case'

import {
  DivTextWorkSpace, StatusTagWorkSpace
} from './styled'

export const options = {
  listSize: [
    { text: '30', value: 30 },
    { text: '60', value: 60 },
    { text: '90', value: 90 },
    { text: '120', value: 120 }
  ],
}

const docStatus = { 2: 'In Progress', 3: 'Revise', 4: 'Completed', 5: 'Reject' }

export const columns = [{
    Header: '',
    accessor: 'isSpecialCreditTerm',
    width: 30,
    Cell: row => (row.value && <Icon name='star' color='yellow' />)
  }, {
    Header: 'Doc No.',
    accessor: 'folio',
    width: 150
  }, {
    Header: () => (<DivTextWorkSpace left>Title</DivTextWorkSpace>),
    accessor: row => (row.title.trim()),
    id: 'title',
    width: 230
  }, {
    Header: () => (<DivTextWorkSpace left>Project name</DivTextWorkSpace>),
    accessor: 'projectName',
    width: 170
  }, {
    Header: 'CompanyName',
    accessor: row => (row.companyCode && row.companyName ? `${row.companyCode}:${row.companyName}` : '-'),
    id: 'companyName',
    width: 120,
    Cell: row => (row.value && <div>{row.value}</div>)
  }, {
    Header: 'Priority',
    accessor: 'priority',
    width: 60,
    Cell: row => (
      row.value &&
        <DivTextWorkSpace>
          <div className={`priority ${lower(row.value)}`}>{upper(row.value)}</div>
        </DivTextWorkSpace>
    )
  }, {
    Header: 'Requester',
    accessor: 'requesterName',
    width: 120,
  }, {
    Header: 'SLA Status',
    accessor: 'slaStatus',
    width: 90,
    Cell: row => (<DivTextWorkSpace center>{row.value}</DivTextWorkSpace>)
  }, {
    Header: 'SLA Due Date',
    accessor: 'slaDueDate',
    width: 120,
    Cell: row => (
      <DivTextWorkSpace center>
        {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : <div>-</div>}
      </DivTextWorkSpace>
    )
  }, {
    Header: 'Modify date',
    accessor: 'startDate',
    width: 120,
    Cell: row => (
      <DivTextWorkSpace center>
        {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : <div>-</div>}
      </DivTextWorkSpace>
    )
  }, {
    Header: 'Submitted date',
    accessor: 'submitDate',
    width: 120,
    Cell: row => (
      <DivTextWorkSpace center>
        {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : <div>-</div>}
      </DivTextWorkSpace>
    )
  }
]